var _tspan, _tspan2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPoweredBy = function SvgPoweredBy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 163 29",
    width: "163px",
    height: "29px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    style: {},
    transform: "matrix(0.707327, 0, 0, 0.707327, 10.407543, 0.428432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-30.000000, -965.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "foot",
    transform: "translate(0.000000, 935.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "powered-by",
    fontFamily: "Helvetica",
    fontSize: 10,
    fontWeight: "normal",
    letterSpacing: 0.5,
    fill: "#9B9B9B",
    style: {
      whiteSpace: "pre"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    y: 10
  }, "powered b")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 92.1992188,
    y: 10
  }, "y"))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.278807, 0, 0, 0.278807, 5.292551, 2.702615)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.63,51.35c-.13,0-.25,.03-.37,.09-.12,.06-.23,.14-.34,.23-.35,.32-.71,.59-1.07,.81-.36,.22-.74,.4-1.14,.54s-.84,.24-1.31,.3c-.48,.06-1.01,.1-1.59,.1-.98,0-1.9-.18-2.75-.55-.85-.37-1.6-.9-2.23-1.59-.63-.69-1.13-1.55-1.5-2.56-.37-1.01-.55-2.17-.55-3.48s.17-2.44,.51-3.45c.34-1.01,.82-1.86,1.44-2.56,.62-.7,1.36-1.23,2.22-1.6,.86-.37,1.81-.55,2.84-.55,.61,0,1.14,.05,1.61,.14,.46,.09,.87,.2,1.23,.34,.35,.13,.66,.28,.93,.44s.5,.31,.71,.44c.2,.13,.39,.25,.56,.34,.17,.09,.34,.14,.5,.14,.23,0,.42-.05,.55-.14,.13-.1,.24-.21,.33-.34l1.44-2c-.92-.9-2.03-1.62-3.34-2.18-1.31-.55-2.81-.83-4.49-.83s-3.25,.29-4.64,.87c-1.4,.58-2.6,1.4-3.61,2.44-1.01,1.05-1.79,2.29-2.35,3.74-.56,1.45-.83,3.04-.83,4.78s.26,3.31,.78,4.76c.52,1.45,1.26,2.7,2.23,3.75s2.14,1.86,3.52,2.45,2.92,.88,4.64,.88c1.92,0,3.57-.31,4.94-.93,1.37-.62,2.53-1.51,3.47-2.67l-1.7-1.84c-.18-.18-.39-.27-.62-.27Z",
    style: {
      fill: "rgb(35, 155, 195)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.88,33.65l-9.11,23.16h3.36c.36,0,.67-.1,.91-.3,.25-.2,.41-.43,.5-.67l1.73-4.72h9.59l1.73,4.72c.12,.28,.29,.51,.53,.7,.23,.19,.54,.28,.91,.28h3.33l-9.1-23.16h-4.39Zm-1.49,14.41l2.8-7.67c.14-.35,.28-.77,.43-1.24s.29-.98,.43-1.53c.15,.54,.3,1.05,.45,1.52s.29,.88,.43,1.22l2.82,7.7h-7.37Z",
    style: {
      fill: "rgb(35, 155, 195)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.02,47.48c-.24-.22-.49-.41-.77-.57,.81-.25,1.53-.58,2.17-1.01,.63-.43,1.17-.92,1.6-1.49,.43-.57,.76-1.2,.99-1.89,.23-.69,.34-1.43,.34-2.21,0-.98-.17-1.88-.51-2.7s-.87-1.52-1.59-2.11c-.72-.59-1.64-1.04-2.77-1.37-1.13-.33-2.47-.49-4.04-.49h-7.06v23.16h4.31v-9.05h1.84c.43,0,.75,.06,.97,.18s.42,.31,.6,.59l4.87,7.42c.33,.58,.86,.86,1.6,.86h3.89l-5.8-8.55c-.19-.3-.41-.56-.64-.78Zm-2.52-3.12c-.6,.2-1.31,.3-2.12,.3h-2.69v-7.69h2.75c1.59,0,2.77,.32,3.55,.95s1.16,1.53,1.16,2.71c0,.59-.1,1.13-.29,1.62-.19,.49-.48,.92-.87,1.27s-.89,.64-1.49,.84Z",
    style: {
      fill: "rgb(35, 155, 195)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "232.19 37.08 232.19 33.65 217.59 33.65 217.59 56.81 232.19 56.81 232.19 53.37 221.91 53.37 221.91 46.82 230.01 46.82 230.01 43.5 221.91 43.5 221.91 37.08 232.19 37.08",
    style: {
      fill: "rgb(35, 155, 195)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.98,51.35c-.13,0-.25,.03-.37,.09-.12,.06-.23,.14-.34,.23-.35,.32-.71,.59-1.07,.81-.36,.22-.74,.4-1.14,.54s-.84,.24-1.31,.3c-.48,.06-1.01,.1-1.59,.1-.98,0-1.9-.18-2.75-.55-.85-.37-1.6-.9-2.23-1.59-.63-.69-1.13-1.55-1.5-2.56-.37-1.01-.55-2.17-.55-3.48s.17-2.44,.51-3.45c.34-1.01,.82-1.86,1.44-2.56,.62-.7,1.36-1.23,2.22-1.6,.86-.37,1.81-.55,2.84-.55,.61,0,1.14,.05,1.61,.14,.46,.09,.87,.2,1.23,.34,.35,.13,.66,.28,.93,.44s.5,.31,.71,.44c.2,.13,.39,.25,.56,.34,.17,.09,.34,.14,.5,.14,.23,0,.42-.05,.55-.14,.13-.1,.24-.21,.33-.34l1.44-2c-.92-.9-2.03-1.62-3.34-2.18-1.31-.55-2.81-.83-4.49-.83s-3.25,.29-4.64,.87c-1.4,.58-2.6,1.4-3.61,2.44-1.01,1.05-1.79,2.29-2.35,3.74-.56,1.45-.83,3.04-.83,4.78s.26,3.31,.78,4.76c.52,1.45,1.26,2.7,2.23,3.75s2.14,1.86,3.52,2.45,2.92,.88,4.64,.88c1.92,0,3.57-.31,4.94-.93,1.37-.62,2.53-1.51,3.47-2.67l-1.7-1.84c-.18-.18-.39-.27-.62-.27Z",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.99,39.15c-.48-.88-1.07-1.67-1.75-2.38-.69-.71-1.47-1.31-2.33-1.81-.86-.5-1.82-.88-2.85-1.15-1.04-.27-2.14-.41-3.32-.41-1.75,0-3.35,.3-4.79,.89-1.44,.59-2.68,1.42-3.71,2.47s-1.83,2.31-2.39,3.76c-.57,1.45-.85,3.02-.85,4.72s.28,3.27,.85,4.72c.57,1.45,1.36,2.7,2.39,3.76,1.03,1.06,2.27,1.88,3.71,2.47,1.44,.59,3.04,.89,4.79,.89s3.36-.3,4.8-.89c1.44-.59,2.67-1.42,3.7-2.47,1.02-1.06,1.82-2.31,2.38-3.76,.56-1.45,.84-3.02,.84-4.72,0-1.13-.12-2.21-.38-3.24-.25-1.02-.62-1.98-1.1-2.85Zm-3.44,9.51c-.34,1.01-.83,1.86-1.46,2.56s-1.4,1.24-2.3,1.61c-.9,.37-1.92,.56-3.05,.56s-2.15-.19-3.05-.56c-.9-.37-1.67-.91-2.31-1.61-.64-.7-1.12-1.55-1.47-2.56-.34-1.01-.51-2.15-.51-3.42s.17-2.41,.51-3.42c.34-1.01,.83-1.87,1.47-2.57,.63-.7,1.4-1.24,2.31-1.62,.9-.37,1.92-.56,3.05-.56s2.15,.19,3.05,.56c.9,.37,1.67,.91,2.3,1.62,.63,.71,1.12,1.56,1.46,2.57,.34,1.01,.51,2.15,.51,3.42s-.17,2.41-.51,3.42Z",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.6,47.73c0,.31,.01,.65,.03,1.01,.02,.36,.05,.73,.08,1.1l-12.14-15.5c-.12-.15-.22-.27-.32-.36-.1-.09-.19-.16-.3-.21-.1-.05-.22-.08-.35-.1-.13-.02-.29-.02-.47-.02h-2.26v23.16h3.8v-14.22c0-.6-.03-1.25-.1-1.95l12.09,15.44c.21,.27,.43,.46,.66,.57,.23,.11,.52,.17,.86,.17h2.21v-23.16h-3.8v14.08Z",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.89,47.73c0,.31,.01,.65,.03,1.01,.02,.36,.05,.73,.08,1.1l-12.14-15.5c-.12-.15-.22-.27-.32-.36-.1-.09-.19-.16-.3-.21-.1-.05-.22-.08-.35-.1-.13-.02-.29-.02-.47-.02h-2.26v23.16h3.8v-14.22c0-.6-.03-1.25-.1-1.95l12.09,15.44c.21,.27,.43,.46,.66,.57,.23,.11,.52,.17,.86,.17h2.21v-23.16h-3.8v14.08Z",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "380.45 56.81 395.06 56.81 395.06 53.37 384.78 53.37 384.78 46.82 392.88 46.82 392.88 43.5 384.78 43.5 384.78 37.08 395.06 37.08 395.06 33.65 380.45 33.65 380.45 56.81",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M423.89,51.35c-.13,0-.25,.03-.37,.09-.12,.06-.23,.14-.34,.23-.35,.32-.71,.59-1.07,.81-.36,.22-.74,.4-1.14,.54s-.84,.24-1.31,.3c-.48,.06-1.01,.1-1.59,.1-.98,0-1.9-.18-2.75-.55-.85-.37-1.6-.9-2.23-1.59-.63-.69-1.13-1.55-1.5-2.56-.37-1.01-.55-2.17-.55-3.48s.17-2.44,.51-3.45c.34-1.01,.82-1.86,1.44-2.56,.62-.7,1.36-1.23,2.22-1.6,.86-.37,1.81-.55,2.84-.55,.61,0,1.14,.05,1.61,.14,.46,.09,.87,.2,1.23,.34,.35,.13,.66,.28,.93,.44s.5,.31,.71,.44c.2,.13,.39,.25,.56,.34,.17,.09,.34,.14,.5,.14,.23,0,.42-.05,.55-.14,.13-.1,.24-.21,.33-.34l1.44-2c-.92-.9-2.03-1.62-3.34-2.18-1.31-.55-2.81-.83-4.49-.83s-3.25,.29-4.64,.87c-1.4,.58-2.6,1.4-3.61,2.44-1.01,1.05-1.79,2.29-2.35,3.74-.56,1.45-.83,3.04-.83,4.78s.26,3.31,.78,4.76c.52,1.45,1.26,2.7,2.23,3.75s2.14,1.86,3.52,2.45,2.92,.88,4.64,.88c1.92,0,3.57-.31,4.94-.93,1.37-.62,2.53-1.51,3.47-2.67l-1.7-1.84c-.18-.18-.39-.27-.62-.27Z",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "436.69 33.65 436.69 37.19 443.67 37.19 443.67 56.81 447.98 56.81 447.98 37.19 454.96 37.19 454.96 33.65 436.69 33.65",
    style: {
      fill: "rgb(58, 58, 57)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "matrix(0.278807, 0, 0, 0.278807, 5.292551, 2.702615)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.43,20.85c0,10.36-8.31,18.76-18.57,18.76s-18.57-8.4-18.57-18.76S67.61,2.09,77.87,2.09s18.57,8.4,18.57,18.76",
    style: {
      fill: "rgb(55, 78, 161)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.42,10.83c0,4.55-3.65,8.24-8.16,8.24s-8.16-3.69-8.16-8.24S12.75,2.59,17.26,2.59s8.16,3.69,8.16,8.24",
    style: {
      fill: "rgb(55, 78, 161)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.98,24.19c0,1.53-1.23,2.77-2.74,2.77s-2.74-1.24-2.74-2.77,1.23-2.77,2.74-2.77,2.74,1.24,2.74,2.77",
    style: {
      fill: "rgb(65, 104, 178)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.01,54.05c0,2.47-1.98,4.48-4.43,4.48s-4.43-2-4.43-4.48,1.98-4.48,4.43-4.48,4.43,2.01,4.43,4.48",
    style: {
      fill: "rgb(65, 104, 178)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67,51.47c0,1.27-1.02,2.3-2.27,2.3s-2.27-1.03-2.27-2.3,1.02-2.3,2.27-2.3,2.27,1.03,2.27,2.3",
    style: {
      fill: "rgb(65, 104, 178)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M49.25,45.37c0,10.17-8.16,18.41-18.22,18.41s-18.22-8.24-18.22-18.41,8.16-18.41,18.22-18.41,18.22,8.24,18.22,18.41",
    style: {
      fill: "rgb(2, 165, 213)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.52,39.97c0,.88-.71,1.59-1.58,1.59s-1.58-.71-1.58-1.59,.71-1.59,1.58-1.59,1.58,.71,1.58,1.59",
    style: {
      fill: "rgb(138, 206, 176)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99.26,29.35c0,1.17-.94,2.12-2.1,2.12s-2.1-.95-2.1-2.12,.94-2.12,2.1-2.12,2.1,.95,2.1,2.12",
    style: {
      fill: "rgb(138, 206, 176)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.89,3.05c0,1.68-1.35,3.04-3.01,3.04s-3.01-1.36-3.01-3.04S24.22,.01,25.88,.01s3.01,1.36,3.01,3.04",
    style: {
      fill: "rgb(251, 176, 66)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9.14,14.58c0,1.55-1.24,2.8-2.77,2.8s-2.77-1.25-2.77-2.8,1.24-2.8,2.77-2.8,2.77,1.25,2.77,2.8",
    style: {
      fill: "rgb(138, 206, 176)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M19.07,27.04c0,5.32-4.27,9.64-9.54,9.64S0,32.36,0,27.04s4.27-9.64,9.54-9.64,9.54,4.31,9.54,9.64",
    style: {
      fill: "rgb(227, 99, 112)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M42.39,69.19c0,3.09-2.48,5.59-5.53,5.59s-5.53-2.5-5.53-5.59,2.48-5.59,5.53-5.59,5.53,2.5,5.53,5.59",
    style: {
      fill: "rgb(65, 104, 178)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.28,75.26c0,1.32-1.06,2.39-2.36,2.39s-2.36-1.07-2.36-2.39,1.06-2.39,2.36-2.39,2.36,1.07,2.36,2.39",
    style: {
      fill: "rgb(35, 155, 195)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.92,49.37c0,5.28-4.24,9.56-9.46,9.56s-9.46-4.28-9.46-9.56,4.24-9.56,9.46-9.56,9.46,4.28,9.46,9.56",
    style: {
      fill: "rgb(35, 155, 195)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M68.57,3.05c0,1.23-.99,2.23-2.21,2.23s-2.21-1-2.21-2.23,.99-2.23,2.21-2.23,2.21,1,2.21,2.23",
    style: {
      fill: "rgb(251, 176, 66)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.61,5.48c0,1.67-1.34,3.02-2.99,3.02s-2.99-1.35-2.99-3.02,1.34-3.02,2.99-3.02,2.99,1.35,2.99,3.02",
    style: {
      fill: "rgb(35, 155, 195)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M28.47,22.88c0,2.66-2.13,4.82-4.77,4.82s-4.77-2.16-4.77-4.82,2.13-4.82,4.77-4.82,4.77,2.16,4.77,4.82",
    style: {
      fill: "rgb(251, 176, 66)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M77.31,61.38c0,1.35-1.09,2.45-2.43,2.45s-2.43-1.1-2.43-2.45,1.09-2.45,2.43-2.45,2.43,1.1,2.43,2.45",
    style: {
      fill: "rgb(138, 206, 176)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52.17,62.32c0,2.58-2.07,4.66-4.61,4.66s-4.62-2.09-4.62-4.66,2.07-4.66,4.62-4.66,4.61,2.09,4.61,4.66",
    style: {
      fill: "rgb(227, 99, 112)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M99.29,25.1c0,.86-.69,1.55-1.53,1.55s-1.53-.69-1.53-1.55,.69-1.55,1.53-1.55,1.53,.69,1.53,1.55",
    style: {
      fill: "rgb(251, 176, 66)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.44,12.66c0,1.1-.89,2-1.98,2s-1.98-.89-1.98-2,.89-2,1.98-2,1.98,.89,1.98,2",
    style: {
      fill: "rgb(227, 99, 112)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M33.73,23.68c0,1.34-1.08,2.43-2.4,2.43s-2.4-1.09-2.4-2.43,1.07-2.43,2.4-2.43,2.4,1.09,2.4,2.43",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.06,12.16c0,5.12-4.11,9.28-9.18,9.28s-9.18-4.15-9.18-9.28S29.81,2.88,34.88,2.88s9.18,4.15,9.18,9.28",
    style: {
      fill: "rgb(59, 181, 74)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.75,11.4c0,2.45-1.97,4.44-4.39,4.44s-4.39-1.99-4.39-4.44,1.97-4.44,4.39-4.44,4.39,1.99,4.39,4.44",
    style: {
      fill: "rgb(59, 181, 74)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.71,1.03c0,.56-.45,1.02-1.01,1.02s-1.01-.46-1.01-1.02S72.15,.01,72.7,.01s1.01,.46,1.01,1.02",
    style: {
      fill: "rgb(59, 181, 74)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.88,41.26c0,5.16-4.14,9.33-9.24,9.33s-9.24-4.18-9.24-9.33,4.14-9.33,9.24-9.33,9.24,4.18,9.24,9.33",
    style: {
      fill: "rgb(59, 181, 74)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.96,42.3c0,2.91-2.33,5.27-5.21,5.27s-5.22-2.36-5.22-5.27,2.33-5.27,5.22-5.27,5.21,2.36,5.21,5.27",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.32,76.88c0,5.24-4.2,9.49-9.39,9.49s-9.39-4.25-9.39-9.49,4.2-9.49,9.39-9.49,9.39,4.25,9.39,9.49",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.57,41.69c0,2.44-1.96,4.42-4.38,4.42s-4.38-1.98-4.38-4.42,1.96-4.42,4.38-4.42,4.38,1.98,4.38,4.42",
    style: {
      fill: "rgb(59, 181, 74)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M59.19,24.09c0,5.23-4.19,9.46-9.36,9.46s-9.36-4.24-9.36-9.46,4.19-9.46,9.36-9.46,9.36,4.24,9.36,9.46",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.67,35.01c0,1.94-1.56,3.52-3.48,3.52s-3.48-1.58-3.48-3.52,1.56-3.52,3.48-3.52,3.48,1.58,3.48,3.52",
    style: {
      fill: "rgb(227, 99, 112)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M72.47,63.3c0,5.17-4.15,9.36-9.27,9.36s-9.27-4.19-9.27-9.36,4.15-9.36,9.27-9.36,9.27,4.19,9.27,9.36",
    style: {
      fill: "rgb(251, 176, 66)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.7,66.36c0,1.32-1.06,2.39-2.36,2.39s-2.36-1.07-2.36-2.39,1.06-2.39,2.36-2.39,2.36,1.07,2.36,2.39",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.43,47.85c0,1.07-.86,1.94-1.92,1.94s-1.92-.87-1.92-1.94,.86-1.94,1.92-1.94,1.92,.87,1.92,1.94",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M5.41,37.13c0,1.07-.86,1.94-1.92,1.94s-1.92-.87-1.92-1.94,.86-1.94,1.92-1.94,1.92,.87,1.92,1.94",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M71.35,1.44c0,.79-.64,1.44-1.42,1.44s-1.42-.64-1.42-1.44,.64-1.44,1.42-1.44,1.42,.64,1.42,1.44",
    style: {
      fill: "rgb(107, 207, 245)",
      fillRule: "evenodd"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPoweredBy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PoweredBy.4da1278b.svg";
export { ForwardRef as ReactComponent };